import {
  initTable,
  formatNameHeaderColumn,
  addPointInteger,
  downloadPDFTable,
  downloadCSVTable,
} from 'vlcishared';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL } from './texts';

const FECHA = 'fecha_estado';
const TAREAS_REALIZADAS = 'total_tareas_realizadas';
const TAREAS_PENDIENTES = 'total_tareas_pendientes';
const CARGA_ADMIN = 'carga_administrativa';
const NUM_USUARIOS = 'num_usuarios';
const NOMBRE_FICHERO = 'Tareas Ayuntamiento';

const commonObjectMetric = {
  sorter: 'string',
  width: '21%',
  hozAlign: 'center',
  headerHozAlign: 'center',
  formatter: function formatDecimal(cell) {
    return addPointInteger(cell.getValue());
  },
};

const columnasTabla = [
  {
    title: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get('mes'),
    field: FECHA,
    width: '17%',
    hozAlign: 'center',
    headerHozAlign: 'center',
    titleFormatter: function format(cell) {
      return formatNameHeaderColumn(cell, 7);
    },
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_realizadas',
      ),
    field: TAREAS_REALIZADAS,
    ...commonObjectMetric,
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_pendientes',
      ),
    field: TAREAS_PENDIENTES,
    ...commonObjectMetric,
  },
  {
    title: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
      'carga_administrativa',
    ),
    field: CARGA_ADMIN,
    ...commonObjectMetric,
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'num_usuarios',
      ),
    field: NUM_USUARIOS,
    ...commonObjectMetric,
  },
];

export async function echartTablaTareasAyuntamiento(datos) {
  const dataObj = datos.resultset.map((item) => ({
    [FECHA]: item[0],
    [TAREAS_REALIZADAS]: item[1],
    [TAREAS_PENDIENTES]: item[2],
    [CARGA_ADMIN]: item[3],
    [NUM_USUARIOS]: item[4],
  }));
  const option = {
    height: '100%',
    scrollable: true,
    layout: 'fitDataTable',
    columns: columnasTabla,
    data: dataObj,
  };

  const table = await initTable('tablaAyuntamiento', option);

  // Descargar tabla en CSV
  downloadCSVTable(table, NOMBRE_FICHERO, 'download-csv_Ayto');

  // Descargar tabla PDF
  downloadPDFTable(table, NOMBRE_FICHERO, 'download-pdf_Ayto');
}
